import { useState } from 'react'
import { useSelector } from 'react-redux'

import ChallengeDetailsModal from './ChallengeDetailsModal'

const ChallengeCardSimple = ({ challenge }) => {
	const [challengeModalOpen, setChallengeModalOpen] = useState(false)
	const companies = useSelector((state) => state['account']?.company)
	const organisations = useSelector((state) => state['account']?.organisation)

	const openChallengeModal = async () => {
		setChallengeModalOpen(true)
	}

	const getEntityName = (challenge) => {
		let entity = null
		if (challenge?.attributes?.isInternalChallenge) {
			entity = organisations[challenge?.attributes?.organisationId]
		} else {
			entity = companies[challenge?.relationships?.company?.data?.id]
		}
		return entity?.attributes?.name ?? 'Unassigned'
	}

	const modal = challengeModalOpen && (
		<ChallengeDetailsModal
			isOpen={challengeModalOpen}
			challengeId={challenge?.id}
			onClose={() => setChallengeModalOpen(false)}
		/>
	)

	return (
		<div className="flex-1 bg-white relative rounded overflow-hidden shadow border border-gray-200 text-left pt-2">
			<span className="px-3 text-xs text-gray-600 uppercase">Challenge</span>
			<h3 className="font-semibold block px-3">
				{challenge?.attributes?.title}
			</h3>
			<small className="text-gray-600 block text-sm px-3">
				By {getEntityName(challenge)}
			</small>
			<small className="text-xs block px-3 mt-2 text-gray-600">
				Preferred teams:{' '}
				<strong>{challenge?.attributes?.teamCountPreference}</strong>
			</small>
			<button
				className="uppercase bg-blue-100 border-t block w-full rounded-none font-bold p-2 mt-2 text-blue-500 hover:text-blue-700 hover:bg-blue-200 transition-colors duration-300 right-0 text-xs"
				onClick={() => openChallengeModal()}
			>
				View details
			</button>
			{modal}
		</div>
	)
}

export default ChallengeCardSimple
